import React, {
  useState,
  useEffect
} from 'react';

import { Form, Field } from "react-final-form";

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  CircularProgress,
  Grid,
  Typography,
  Button,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  InputLabel,
  MenuItem,
  ListSubheader,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  colors,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';

import {
  ObservableAPI,
} from '../../../data/ObservableAPI';
import {
  ThesisProposalReview
} from '../../../types';

import localization from '../../../utils/localizations';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
    marginTop: 20,
    marginBottom: 20,
  },
  mainGrid: {
    padding: 8,
  },
  gridLabelBolder: {
    textAlign: 'right',
    fontWeight: 500,
  },
  gridLabel: {
    textAlign: 'right',
    color: '#555555',
  },
  alignRight: {
    textAlign: 'right',
  },
  form: {
    marginRight: 30,
  }
}));

function ThesisProposalGradingReviewViewer(props: {
  reviewId: string;
  reviewerName?: string;
}) {
  const classes = useStyles();
  const [review, setReview] = useState(undefined as ThesisProposalReview|undefined);
  const [showForm, setShowForm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const loadReview = async (id: string) => {
    if (isSaving) return;

    const api = new ObservableAPI();
    setIsLoading(true);
    try {
      const result = await api.get(`thesis-proposal-reviews/${id}/`);
      if (result && (result as any).id) setReview(result as ThesisProposalReview);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadReview(props.reviewId);
  }, [props.reviewId]);

  if (!isLoading && review?.status === 'final') {
    return (<ThesisProposalReviewViev review={review} reviewerName={props.reviewerName} />);
  }
  return <></>;
}

function ThesisProposalReviewViev(props: {
  review: ThesisProposalReview,
  reviewerName?: string;
}) {
  const classes = useStyles();

  let title = localization.ugbReview;
  if (props.reviewerName) {
    title = `${title} - ${props.reviewerName}`
  }

  return (
    <Paper className={classes.mainBody}>
      <ListSubheader style={{paddingLeft: 8}}>{title}</ListSubheader>
      <List dense>
        <ListItem>
          <ListItemText
            primary="Catatan untuk mahasiswa"
            secondary={props.review.notes_for_student ? <span style={{whiteSpace: 'pre-line'}}>{props.review.notes_for_student}</span> : <MoreHorizIcon style={{ color: colors.grey[500] }} />}
          />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            {(props.review.reccommendation === 'approved') && <CheckIcon style={{ color: colors.green[500] }} />}
            {(props.review.reccommendation === 'approved_with_revision') && <CheckIcon style={{ color: colors.orange[500] }} />}
            {(props.review.reccommendation === 'presentation_required') && <CheckIcon style={{ color: colors.orange[500] }} />}
            {(props.review.reccommendation === 'rejected') && <CloseIcon style={{ color: colors.red[500] }} />}
          </ListItemIcon>
          <ListItemText
            primary="Rekomendasi Reviewer"
            secondary={<div>{props.review.reccommendation === 'approved' ? <b style={{color: 'green'}}>Disetujui, tanpa perbaikan</b> : ''}
            {props.review.reccommendation === 'approved_with_revision' ? <b style={{color: 'orange'}}>Masih perlu perbaikan</b> : ''}
            {props.review.reccommendation === 'presentation_required' ? <b style={{color: 'orange'}}>Perlu diperjelas dengan presentasi</b> : ''}
            {props.review.reccommendation === 'rejected' ? <b style={{color: 'red'}}>Tidak disetujui, harus mengganti judul penelitian</b> : ''}</div>}
          />
        </ListItem>
      </List>
    </Paper>
  );
}

export {ThesisProposalGradingReviewViewer};